export const environment = {
  production: true,
  apiEndpoint: 'https://api.new.devpage.pl',
  clientId: '2f1419bb-45bd-4851-a540-5ed9f4539a8c',
  clientSecret: '0d219459564549969b9e299acea3c5e4',
  ADS_FEATURE: true,
  TEST_FEATURE: false
};

